import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { X } from "lucide-react";
import DashboardHeader from "./DashboardHeader";
import Sidebar from "./Sidebar";
import { FloatingHelpButton } from "../../features/support";
import RepGuardInstallPrompt from "../../features/repguard/RepGuardInstallPrompt";

export default function AuthenticatedLayout({
  children,
  showSidebar = true,
  showHeader = true,
}) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  // Close the mobile drawer whenever the route changes
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  if (!showSidebar && !showHeader) {
    return children;
  }

  if (!showSidebar) {
    return (
      <div className="flex flex-col h-screen">
        {showHeader && <DashboardHeader />}
        <RepGuardInstallPrompt />
        <div className="flex-1 overflow-auto">{children}</div>
        <FloatingHelpButton />
      </div>
    );
  }

  return (
    <div className="flex h-screen">
      {/* Sidebar - static on desktop */}
      <div className="hidden md:block flex-shrink-0">
        <Sidebar />
      </div>

      {/* Sidebar - slide-in drawer on mobile */}
      {mobileOpen && (
        <div className="md:hidden">
          <div
            className="fixed inset-0 z-40 bg-black/50"
            onClick={() => setMobileOpen(false)}
            aria-hidden="true"
          />
          <div className="fixed inset-y-0 left-0 z-50 w-64 max-w-[80vw] shadow-xl">
            <button
              onClick={() => setMobileOpen(false)}
              className="absolute right-3 top-4 z-10 rounded-lg p-1.5 text-neutral-300 hover:bg-card/10 hover:text-white"
              aria-label="Close menu"
            >
              <X className="h-5 w-5" />
            </button>
            <Sidebar />
          </div>
        </div>
      )}

      <div className="flex flex-col flex-1 min-w-0">
        {showHeader && (
          <div className="flex-shrink-0">
            <DashboardHeader onMenuClick={() => setMobileOpen(true)} />
          </div>
        )}
        <RepGuardInstallPrompt />
        <div className="flex-1 overflow-auto">
          {children}
        </div>
      </div>

      <FloatingHelpButton />
    </div>
  );
}
